import React from 'react';
import { Form, Input, Row, Col, Button } from 'antd';
const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class WallForm extends React.Component {
    constructor() {
        super();
        this.state = {
            content:null,
            code:null,
        }
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({}, fieldsValue, {photo: this.state.photo}));
        });
    }

    render() {        
        const formItemLayout = {
            labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
            wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{direction: 'rtl'}}>
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col span={20} offset={2}>
                        <FormItem
                        {...formItemLayout}
                        label="code"
                        style={{direction:'ltr'}}
                        colon={false}>
                            {getFieldDecorator('code', {
                                initialValue: this.props.initialData.code,
                                rules: [
                                ],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                        {...formItemLayout}
                        label="content"
                        style={{direction:'rtl'}}
                        colon={false}>
                            {getFieldDecorator('content', {
                                initialValue: this.props.initialData.content,
                                rules: [
                                { required: true, message: 'این قسمت الزامی است.' },
                                ],
                            })(
                                <Input.TextArea />
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                <Col span={24}>
                    <FormItem>
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={hasErrors(getFieldsError()) || this.props.submitted}
                            style={{width: '10%', margin: '0px 45%'}}>
{this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                        </Button>
                    </FormItem>
                </Col>
                </Row>  
            </Form>
            </div>
        );
    }
}

WallForm.defaultProps = {
    initialData: {}
}

export default Form.create()(WallForm);


// WEBPACK FOOTER //
// ./src/containers/Wall/form.js